import { siteRoutingActionCreators } from '@app/routes/Development/Clients/Sites/View/modules/developmentSiteView'
import { connect } from 'react-redux'
import { DevelopmentSiteResultItem } from '../components/DevelopmentSiteResultItem'

export default connect(
  () => ({}),
  { ...siteRoutingActionCreators },
)(DevelopmentSiteResultItem)
